module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "width": "90%"
    },
    model: {
      value: (_vm.modalState),
      callback: function($$v) {
        _vm.modalState = $$v
      },
      expression: "modalState"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#19be6b",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "android-add-circle"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Add Detail(s)")])], 1), _vm._v(" "), _c('Card', [_c('Card', [_c('Row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "8"
    }
  }, [_c('label', {
    attrs: {
      "for": "Container Number"
    }
  }, [_vm._v("Container Number : ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.dataHot.containerNumber))])]), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "8"
    }
  }, [_c('label', {
    attrs: {
      "for": "Sum of Vol"
    }
  }, [_vm._v("Sum of Vol : ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.dataHot.sumOfVol))])]), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "8"
    }
  }, [_c('label', {
    attrs: {
      "for": "Sum of Uang Yg Akan Diterima"
    }
  }, [_vm._v("Sum of Uang Yg Akan Diterima : ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.dataHot.sumOfUYAD))])])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('HotTable', {
    ref: "hotTableComponent",
    attrs: {
      "settings": _vm.hotSettings,
      "data": _vm.dataHot
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "disabled": !_vm.isDataFilled,
      "loading": _vm.isSubmitButton,
      "type": "success"
    },
    on: {
      "click": _vm.actionPostDetail
    }
  }, [(!_vm.isSubmitButton) ? _c('span', [_vm._v("Simpan Data")]) : _c('span', [_vm._v("Sedang diproses.....")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c321728","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/omset/cHotOmsetAddDetail.vue
// module id = 1783
// module chunks = 1